export const SUPER_ADMIN_ROLE_ID = 1;

export default {
	CAN_ASSIGN_KYC_AGENTS: 'assign_kyc-agent',
	CAN_VIEW_MANUAL_KYC_ADMIN: 'is_manual-kyc-admin',
	CAN_VIEW_MANUAL_KYC: 'can_view_manual_kyc',
	CAN_VIEW_MANUAL_KYC_QA: 'can_view-manual-kyc-qa',
	CAN_VIEW_SHOP_VALIDATOR: 'can_view_shop_validator_list',
	CAN_VIEW_SHOP_VALIDATOR_ADMIN: 'is_shop-validator-admin',
	CAN_VIEW_SHOP_REJECT: 'inside_sales_shop_picture_reject',
	CAN_POS_IMAGE_ADMIN: 'can_pos_image_admin',
	CAN_POS_IMAGE_MAKER: 'can_pos_image_maker',
	CAN_POS_IMAGE_CHECKER: 'can_pos_image_checker',
};
